import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_90ka4e3htb: FaireBrandEntity = {
  token: "b_90ka4e3htb",
  type: "brand",
  name: "Voir Haircare",
  avatarUrl:
    "https://cdn.faire.com/fastly/6958bfeef764f0dd62bbacc4bee9568a96c25f03c6563e50e3b33d74a631ff25.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e504cb6d3b76486932b8da7dfebf3aeb7932db5fd1a048c256da409f697d2656.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6958bfeef764f0dd62bbacc4bee9568a96c25f03c6563e50e3b33d74a631ff25.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e504cb6d3b76486932b8da7dfebf3aeb7932db5fd1a048c256da409f697d2656.png",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: false,
  description:
    "Voir Haircare // Inspired by the art of nature.\n\nVoir is a collection of premium salon-quality haircare essentials designed to elevate your daily hair routine by combining mindful ingredients, captivating artistry inspired by Canada’s ever-changing seasonal landscapes, and incredible hair days. Founded by a beauty creative in Toronto, Ontario, we create a true sensory experience that specializes in hair wellness and feels like an escape to the Canadian wild.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.622Z",
    importedBy: "entity-db-cli",
  },
};
